import { render, staticRenderFns } from "./AvatarCircle.vue?vue&type=template&id=2071acaf&scoped=true&"
import script from "./AvatarCircle.vue?vue&type=script&lang=js&"
export * from "./AvatarCircle.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCircle.vue?vue&type=style&index=0&id=2071acaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071acaf",
  null
  
)

export default component.exports